import RolesUserPageDetalle from './RolesUserPageDetalle';

export default RolesUserPageDetalle;
